import gettext from 'i18n/gettext';
const flow = {
    name: gettext('Secondary Owner'),
    steps: [
        {
            key: 'personal-info',
            state: 'setup.add-owner.personal-info',
            heading: gettext('Personal Details'),
            label: gettext('Personal Info'),
            returnTo: 'setup',
            keepStateOnPrev: true,
        },
        {
            key: 'step1',
            state: 'setup.add-owner.step1',
            heading: gettext('Personal Details'),
            label: gettext('Current Address'),
            keepStateOnPrev: true,
        },
        {
            key: 'step2',
            state: 'setup.add-owner.step2',
            heading: gettext('Source of Funds'),
            label: gettext('Source of Funds'),
        },
        {
            key: 'step3',
            state: 'setup.add-owner.step3',
            heading: gettext('Employment Status'),
            label: gettext('Employment Status'),
        },
        {
            key: 'review',
            state: 'setup.add-owner.review',
            heading: gettext('Review & Confirm Information'),
            label: gettext('Review'),
        },
        {
            key: 'complete',
            state: 'setup.add-owner.complete',
            label: gettext('Complete'),
        },
    ],
};
export default flow;



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/onboarding/controllers/setup/add-owner/add-owner-flow.ts